import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

import {
  REACT_APP_INSIGHTS_ACCOUNT_ID,
  REACT_APP_INSIGHTS_INSTRUMENTATION_KEY,
} from "./configs";

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    accountId: REACT_APP_INSIGHTS_ACCOUNT_ID,
    instrumentationKey: REACT_APP_INSIGHTS_INSTRUMENTATION_KEY,
    extensions: [reactPlugin],
  },
});
appInsights.loadAppInsights();

export { reactPlugin, appInsights };
